<div class="container dialog-container">

  <h2 class="display-6">
    {{ isEditing ? 'Edit Species' : 'Add Species' }}
  </h2>

  <!-- Search for species -->
  <form [formGroup]="form">
    <div class="row">
      <mat-form-field>
        <mat-label>
          Species
        </mat-label>
        <input matInput
               #speciesInput
               required
               formControlName="species"
               [matAutocomplete]="auto"
               [readonly]="isEditing">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySpecies">
          <mat-option *ngFor="let fSpecies of filteredSpecies | async"
                      [value]="fSpecies">
            {{ fSpecies.name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="form.invalid">
          Select an item
        </mat-error>
      </mat-form-field>
    </div>
  </form>

  <!-- Cancel or add new species -->
  <div class="buttons">

    <button mat-fab
            class="text-blue-button"
            type="button"
            [attr.aria-label]="isEditing ? 'Delete Species' : 'Cancel'"
            (click)="onCancelOrDelete()">
      {{ isEditing ? 'Delete' : 'Cancel' }}
    </button>

    <button mat-fab
            class="text-button"
            type="button"
            aria-label="Add Species"
            (click)="addSpecies()">
      OK
    </button>

  </div>

</div>
